module.exports = __webpack_public_path__ + "static/media/7.f8e07410.png";